import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Provimento',
  path: '/pessoal/pesprovimento',
  name: 'pesprovimento',
  component: () => import('@/views/pessoal/pesprovimento/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.PROVIMENTONOVO_MENU_1400701399],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Provimento',
  path: '/pessoal/pesprovimento/cadastro/:id?',
  parent: 'pesprovimento',
  name: 'pesprovimento_create',
  component: () => import('@/views/pessoal/pesprovimento/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.PROVIMENTONOVO_MENU_1400701399],
  },
  goesToMenu: true,
 },
]
